export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'platform-news',
    name: '平台资讯',
    description: '了解g点网最新动态、版本更新及平台公告',
    icon: 'ri-newspaper-line',
    articleCount: 48,
  },
  {
    id: 'cat-2',
    slug: 'usage-guide',
    name: '使用指南',
    description: '从入门到精通，详细的使用教程与操作指引',
    icon: 'ri-book-open-line',
    articleCount: 126,
  },
  {
    id: 'cat-3',
    slug: 'feature-tutorial',
    name: '功能介绍',
    description: '深入解析g点网各项核心功能的使用技巧',
    icon: 'ri-tools-line',
    articleCount: 87,
  },
  {
    id: 'cat-4',
    slug: 'security',
    name: '安全中心',
    description: '账号安全防护、隐私设置与风险防范指南',
    icon: 'ri-shield-check-line',
    articleCount: 64,
  },
  {
    id: 'cat-5',
    slug: 'faq',
    name: '常见问题',
    description: '汇集用户最常遇到的问题及官方解答',
    icon: 'ri-question-answer-line',
    articleCount: 93,
  },
];